import { useEffectOnce } from 'js/hooks/useEffectOnce';
import { useLocation } from 'react-router-dom';
import { setRefereeCookie } from 'js/utils/referrer.util';

export const useReferrer = () => {
    const location = useLocation();

    useEffectOnce(() => {
        const params = Object.fromEntries(new URLSearchParams(location.search));

        setRefereeCookie(params);
        setRefereeCookie(params, 'refuser');
    }, [location]);
};
